import React from 'react';
import LoadingButton from './LoadingButton';

export interface ButtonProps {
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  icon?: React.JSX.Element;
  title?: string;
}

export default function Button(props: React.PropsWithChildren<ButtonProps>) {
  const { type, onClick, disabled, loading, children, icon, title } = props;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={[props.className, loading ? 'btn-loading' : '']
        .filter(Boolean)
        .join(' ')}
      title={title}
    >
      {loading ? (
        <LoadingButton />
      ) : (
        <>
          {icon && <span className="btn-icon">{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
}

Button.defaultProps = {
  type: 'button',
  disabled: false,
  loading: false,
};
